import React from "react";
import { Route } from "react-router-dom";
import { BrowserRouter as Router, Redirect } from "react-router-dom";
import { Switch } from "react-router-dom";
//CSS & Bootstrap
import "./assets/css/style.css";

import { Login } from "./pages/Authentication";
// import config from "config";
import BlogView from "./pages/Profile/BlogView";
import PendingBlog from "./pages/Profile/PendingBlog";
import AddBlog from "./pages/Profile/AddBlog";
import EditBlog from "./pages/Profile/EditBlog";
import BlankPage from "./pages/Blank/BlankPage";
import BasicTable from "./pages/Table/BasicTable";
import DataTable from "./pages/Table/DataTable";
import Students from "./pages/Students/StudentsList";
import InvoiceGrid from "./pages/Invoice/InvoiceGrid";
import AddInvoice from "./pages/Invoice/AddInvoice";
import EditInvoice from "./pages/Invoice/EditInvoice";
import ViewInvoice from "./pages/Invoice/ViewInvoice";
import InvoiceSettings from "./pages/Invoice/InvoiceSettings";
import InvoiceList from "./pages/Invoice/InvoiceList";
import Register from "./pages/Authentication/Register";
import ForgotPassword from "./pages/Authentication/ForgotPassword";
import AdminDashboard from "./pages/Dashboard/AdminDashboard";
import Blogdetails from "./pages/Profile/Blogdetails";
import Profile from "./pages/Profile/Profile";
import TaxSetting from "./pages/Invoice/TaxSetting";
import BankSetting from "./pages/Invoice/BankSetting";
import Inbox from "./components/Header/Inbox ";
import Compose from "./components/Header/Compose";
import StudentsDashboard from "./pages/Dashboard/StudentsDashboard";
import TeacherDashboard from "./pages/Dashboard/TeacherDashboard";
import StudentsView from "./pages/Students/StudentsView";
import EditStudent from "./pages/Students/EditStudent";
import StudentGrid from "./pages/Students/StudentGrid";
//Users
import UsersList from "./pages/Users/UserList";
import AddUser from "./pages/Users/AddUser";
import EditUser from "./pages/Users/EditUser";
import UserGrid from "./pages/Users/UserGrid";

//students
import AddStudent from "./pages/Students/AddStudent";

//LiveStream
import LiveStream from "./pages/LiveStream/LiveStream";

//
import Quiz from "./pages/Quiz/Quiz";

//Resources
import Resources from "./pages/Resources/Resources";

//Modules
import ModulesList from "./pages/Modules/ModuleList";
import InvoicePaid from "./pages/Invoice/InvoicePaid";
import InvoiceOverdue from "./pages/Invoice/InvoiceOverdue";
import InvoiceDraft from "./pages/Invoice/InvoiceDraft";
import InvoiceRecurring from "./pages/Invoice/InvoiceRecurring";
import InvoiceCancelled from "./pages/Invoice/InvoiceCancelled";

//Facilitator
import FacilitatorList from "./pages/Facilitator/FacilitatorList";
import AddFacilitator from "./pages/Facilitator/AddFacilitator";
import EditFacilitator from "./pages/Facilitator/EditFacilitator";
import FacilitatorGrid from "./pages/Facilitator/FacilitatorGrid";

//Course
import AddLevel from "./pages/Course/AddLevel";
import EditLevel from "./pages/Course/EditLevel";
import ViewLevel from "./pages/Course/LevelView";
import LevelDetails from "./pages/Course/Leveldetails";
import PendingLevel from "./pages/Course/PendingLevel";

//Assessments
import AssessmentAdd from "./pages/Assessments/AddLevel";
import QuizCreator from "./pages/Assessments/QuizCreator";
import LevelView from "./pages/Assessments/LevelView";
import Assessmentdetails from "./pages/Assessments/Leveldetails";
import AssessmentQuestionsAdd from "./pages/Assessments/QuestionsAddLevel";
import EnrolledAssessment from "./pages/Assessments/EnrolledAssessment.jsx";
// import QuizList from "./pages/Assessments/QuizList";
import EditAssessment from "./pages/Assessments/EditLevel";

//Teachers
import TeachersList from "./pages/Teachers/TeachersList";
import TeachersProfile from "./pages/Teachers/TeachersProfile";
import TeachersAdd from "./pages/Teachers/TeachersAdd";
import TeachersEdit from "./pages/Teachers/TeachersEdit";
import TeachersGrid from "./pages/Teachers/TeachersGrid";
import DepartmentList from "./pages/Department/DepartmentList";
import AddDepartment from "./pages/Department/AddDepartment";
import EditDepartment from "./pages/Department/EditDepartment";
import SubjectList from "./pages/Subject/SubjectList";
import AddSubject from "./pages/Subject/AddSubject";
import EditSubject from "./pages/Subject/EditSubject";
// Settings
import GendralSettings from "./pages/Settings/GendralSettings";
import Localization from "./pages/Settings/Localization";
import PaymentSettings from "./pages/Settings/PaymentSettings";
import EmailSettings from "./pages/Settings/EmailSettings";
import SocialSettings from "./pages/Settings/SocialSettings";
import SocialLinks from "./pages/Settings/SocialLinks";
import Seo from "./pages/Settings/Seo";
import OtherSettings from "./pages/Settings/OtherSettings";
//Library
import LibraryList from "./pages/Library/LibraryList";
import AddBook from "./pages/Library/AddBook";
import FeesCollection from "./pages/Accounts/FeesCollection";
import Expenses from "./pages/Accounts/Expenses";
import Salary from "./pages/Accounts/Salary";
import AddFeesCollection from "./pages/Accounts/AddFeesCollection";
import AddExpenses from "./pages/Accounts/AddExpenses";
import AddSalary from "./pages/Accounts/AddSalary";
import Holiday from "./pages/Holiday/Holiday";
import AddHoliday from "./pages/Holiday/AddHoliday";
import Fees from "./pages/Fees/Fees";
import AddFees from "./pages/Fees/AddFees";
import EditFees from "./pages/Fees/EditFees";
import Exam from "./pages/Exam List/Exam";
import AddExam from "./pages/Exam List/AddExam";
import EditExam from "./pages/Exam List/EditExam";
import TimeTable from "./pages/Time Table/TimeTable";
import AddTimeTable from "./pages/Time Table/AddTimeTable";
import EditTimeTable from "./pages/Time Table/EditTimeTable";
import EditBook from "./pages/Library/EditBook";
import Sports from "./pages/Sports/Sports";
import AddSports from "./pages/Sports/AddSports";
import EditSports from "./pages/Sports/EditSports";
import Hostel from "./pages/Hostel/Hostel";
import AddHostel from "./pages/Hostel/AddHostel";
import EditHostel from "./pages/Hostel/EditHostel";
import Transport from "./pages/Transports/Transport";
import AddTransport from "./pages/Transports/AddTransport";
import EditTransport from "./pages/Transports/EditTransport";
import Event from "./pages/Events/Event";
import AddEvent from "./pages/Events/AddEvent";
import BasicTables from "./pages/Table/BasicTable";
import DataTables from "./pages/Table/DataTable";
import BasicInputs from "./pages/Forms/BasicInputs";
import FormInputGroups from "./pages/Forms/FormInputGroups";
import FormMask from "./pages/Forms/FormMask";
import FormValidation from "./pages/Forms/FormValidation";
import HorizontalForm from "./pages/Forms/HorizontalForm";
import VerticalForm from "./pages/Forms/VerticalForm";
import FeatherIcons from "./pages/Icons/Feather";
import FlagIcons from "./pages/Icons/Flag";
import FontawesomeIcons from "./pages/Icons/Font-awesome";
import IonicIcons from "./pages/Icons/Ionic";
import MaterialIcons from "./pages/Icons/Material";
import PE7Icons from "./pages/Icons/Pe7";
import SimplelineIcons from "./pages/Icons/Simpleline";
import ThemifyIcons from "./pages/Icons/Themify";
import WeatherIcons from "./pages/Icons/Weather";
import TypiconIcons from "./pages/Icons/Typicon";
import Ribbon from "./pages/Elements/Ribbon";
import Rating from "./pages/Elements/Rating";
import Texteditor from "./pages/Elements/Texteditor";
import Counter from "./pages/Elements/Counter";
import Scrollbar from "./pages/Elements/ScrollBar";
import Notification from "./pages/Elements/Notification";
import Stickynote from "./pages/Elements/StickyNote";
import Timeline from "./pages/Elements/TimeLine";
import Formwizard from "./pages/Elements/FormWizard";
import HorizontalTimeLine from "./pages/Elements/HorizontalTimeLine";
import ApexCharts from "./pages/Charts/ApexChart";
import ChartJs from "./pages/Charts/ChartJs";
import MorrisCharts from "./pages/Charts/MorrisChart";
import FlotCharts from "./pages/Charts/FlotChart";
import PeityChart from "./pages/Charts/PeityChart";
import C3Charts from "./pages/Charts/C3Chart";
import UiTooltip from "./pages/Base UI/Tooltip";
import Toastr from "./pages/Base UI/Toast";
import Spinner from "./pages/Base UI/Spinner";
import PopOver from "./pages/Base UI/PopOver";
import LightBox from "./pages/Base UI/LightBox";
import Cards from "./pages/Base UI/Cards";
import Pagination from "./pages/Base UI/Pagination";
import Tableavatar from "./pages/Base UI/Avatar";
import Tabs from "./pages/Base UI/Tabs";
import Typography from "./pages/Base UI/Typography";
import Progressbar from "./pages/Base UI/ProgressBar";
import Buttons from "./pages/Base UI/Buttons";
import Video from "./pages/Base UI/Video";
import Sweetalert from "./pages/Base UI/SweetAlert";
import Images from "./pages/Base UI/Images";
import Grid from "./pages/Base UI/Grid";
import ButtonGroup from "./pages/Base UI/ButtonGroup";
import Badge from "./pages/Base UI/Badge";
import Accordion from "./pages/Base UI/Accordion";
import Alert from "./pages/Base UI/Alert";
import PlaceHolder from "./pages/Base UI/PlaceHolder";
import OffCanvas from "./pages/Base UI/OffCanvas";
import Modal from "./pages/Base UI/Modal";
import Media from "./pages/Base UI/Media";
import Carousel from "./pages/Base UI/Carousel";
import BreadCrumbs from "./pages/Base UI/BreadCrumbs";
import Error404 from "./pages/Authentication/Error-404";
import RangeSlider from "./pages/Base UI/RangeSlider";
import DragDrop from "./pages/Elements/Drag&Drop";
import Clipboard from "./pages/Elements/ClipBoard";
import Dropdown from "./pages/Base UI/DropDown";
import EditEvent from "./pages/Events/EditEvent";
import UsersView from "./pages/Users/UserView";
import ResetPassword from "./pages/Authentication/ResetPassword.jsx";



const appcontainer = () => {
  return (
    <Router>
      <Switch>
        {/* <Route path="/" component={AdminDashboard} /> */}
        <Route exact path="/">
          <Redirect to="/login" />
        </Route>
        <Route path="/login" component={Login} />
        <Route path="/register" component={Register} />
        <Route path="/forgot-password" component={ForgotPassword} />
        <Route path="/resetpassword" component={ResetPassword} />
        <Route path="/error404" component={Error404} />
        <Route path="/livesession" component={LiveStream} />
        <Route path="/quizzes" component={Quiz} />
        <Route path="/resources" component={Resources} />

        <Route path="/admindashboard" component={AdminDashboard} />
        <Route path="/teacherdashboard" component={TeacherDashboard} />
        <Route path="/studentdashboard" component={StudentsDashboard} />

        <Route path="/blog" component={BlogView} />
        <Route path="/pendingblog" component={PendingBlog} />
        <Route path="/addblog" component={AddBlog} />
        <Route path="/editblog" component={EditBlog} />
        <Route path="/blogdetails" component={Blogdetails} />
        <Route path="/profile" component={Profile} />

        <Route path="/blankpage" component={BlankPage} />
        <Route path="/basictable" component={BasicTable} />
        <Route path="/datatable" component={DataTable} />

 {/*--------------------------------------------Users -------------------------------*/}
        <Route path="/users" component={UsersView} />
        <Route path="/addadmin" component={AddUser} />
        <Route path="/edituser/:id" component={EditUser} />
        <Route path="/usergrid" component={UserGrid} />
        <Route path="/userlist" component={UsersList} />

 {/*--------------------------------------------Students -------------------------------*/}
        <Route path="/students" component={Students} />
        <Route path="/studentsview" component={StudentsView} />
        <Route path="/addstudent" component={AddStudent} />
        <Route path="/editstudent" component={EditStudent} />
        <Route path="/studentgrid" component={StudentGrid} />

        <Route path="/modules" component={ModulesList} />
        {/* <Route path="/addmodule" component={AddModule} /> */}

        <Route path="/invoicegrid" component={InvoiceGrid} />
        <Route path="/invoicepaid" component={InvoicePaid} />
        <Route path="/invoiceoverdue" component={InvoiceOverdue} />
        <Route path="/invoicedraft" component={InvoiceDraft} />
        <Route path="/invoicerecurring" component={InvoiceRecurring} />
        <Route path="/invoicecancelled" component={InvoiceCancelled} />
        <Route path="/addinvoice" component={AddInvoice} />
        <Route path="/editinvoice" component={EditInvoice} />
        <Route path="/viewinvoice" component={ViewInvoice} />
        <Route path="/invoicesetting" component={InvoiceSettings} />
        <Route path="/invoicelist" component={InvoiceList} />
        <Route path="/taxsetting" component={TaxSetting} />
        <Route path="/banksetting" component={BankSetting} />

        <Route path="/inbox" component={Inbox} />
        <Route path="/compose" component={Compose} />

        {/* Settings */}
        <Route path="/generalsettings" component={GendralSettings} />
        <Route path="/localization" component={Localization} />
        <Route path="/paymentsettings" component={PaymentSettings} />
        <Route path="/emailsettings" component={EmailSettings} />
        <Route path="/socialsettings" component={SocialSettings} />
        <Route path="/sociallinks" component={SocialLinks} />
        <Route path="/seo" component={Seo} />
        <Route path="/othersettings" component={OtherSettings} />

        <Route path="/librarylist" component={LibraryList} />
        <Route path="/addbook" component={AddBook} />
        <Route path="/editbook" component={EditBook} />

        {/*----------------------------------FACILITATOR-----------------------------------------------------*/}
        <Route path="/facilitatorlist" component={FacilitatorList} />
        <Route path="/addfacilitator" component={AddFacilitator} />
        <Route path="/editfacilitator" component={EditFacilitator} />
        <Route path="/facilitatorgrid" component={FacilitatorGrid} />

        {/*------------COURSE/LEVEL--------------------------------------------------------------*/}
        <Route path="/courses" component={ViewLevel} />
        <Route path="/addcourse" component={AddLevel} />
        <Route path="/coursedetails" component={LevelDetails} />
        <Route path="/pendingcourse" component={PendingLevel} />
        <Route path="/editcourse" component={EditLevel} />

        {/*--------------------------------------------ASSESSMENTS -------------------------------*/}
        <Route path="/assessments" component={LevelView} />
        <Route path="/addassessment" component={AssessmentAdd} />
        <Route path="/addassessmentquestions" component={AssessmentQuestionsAdd} />
        <Route path="/editassessment" component={EditAssessment} />
        <Route path="/assignquiz" component={QuizCreator} />
        <Route path="/viewassessment" component={Assessmentdetails} />
        <Route path="/enrolledassessments" component={EnrolledAssessment} />
        {/* <Route path="/viewassessments" component={QuizList} /> */}

        <Route path="/teacherslist" component={TeachersList} />
        <Route path="/teachersprofile" component={TeachersProfile} />
        <Route path="/addteacher" component={TeachersAdd} />
        <Route path="/editteacher" component={TeachersEdit} />
        <Route path="/teachersgrid" component={TeachersGrid} />

        <Route path="/department" component={DepartmentList} />
        <Route path="/adddepartment" component={AddDepartment} />
        <Route path="/editdepartment" component={EditDepartment} />

        <Route path="/subject" component={SubjectList} />
        <Route path="/addsubject" component={AddSubject} />
        <Route path="/editsubject" component={EditSubject} />

        <Route path="/feescollection" component={FeesCollection} />
        <Route path="/addfeescollection" component={AddFeesCollection} />
        <Route path="/expenses" component={Expenses} />
        <Route path="/addexpenses" component={AddExpenses} />
        <Route path="/salary" component={Salary} />
        <Route path="/addsalary" component={AddSalary} />

        <Route path="/holiday" component={Holiday} />
        <Route path="/addholiday" component={AddHoliday} />

        <Route path="/fees" component={Fees} />
        <Route path="/addfees" component={AddFees} />
        <Route path="/editfees" component={EditFees} />

        <Route path="/exam" component={Exam} />
        <Route path="/addexam" component={AddExam} />
        <Route path="/editexam" component={EditExam} />

        <Route path="/timetable" component={TimeTable} />
        <Route path="/addtimetable" component={AddTimeTable} />
        <Route path="/edittimetable" component={EditTimeTable} />

        <Route path="/sports" component={Sports} />
        <Route path="/addsports" component={AddSports} />
        <Route path="/editsports" component={EditSports} />

        <Route path="/hostel" component={Hostel} />
        <Route path="/addhostel" component={AddHostel} />
        <Route path="/edithostel" component={EditHostel} />

        <Route path="/transport" component={Transport} />
        <Route path="/addtransport" component={AddTransport} />
        <Route path="/edittransport" component={EditTransport} />

        <Route path="/event" component={Event} />
        <Route path="/addevent" component={AddEvent} />
        <Route path="/editevent" component={EditEvent} />

        <Route path="/basictable" component={BasicTables} />
        <Route path="/datatable" component={DataTables} />

        <Route path="/basicinput" component={BasicInputs} />
        <Route path="/forminputgroup" component={FormInputGroups} />
        <Route path="/formmask" component={FormMask} />
        <Route path="/formvalidation" component={FormValidation} />
        <Route path="/horizontalform" component={HorizontalForm} />
        <Route path="/verticalform" component={VerticalForm} />

        <Route path="/feathericons" component={FeatherIcons} />
        <Route path="/flagicons" component={FlagIcons} />
        <Route path="/fontawesomeicons" component={FontawesomeIcons} />
        <Route path="/iconicicons" component={IonicIcons} />
        <Route path="/materialicons" component={MaterialIcons} />
        <Route path="/flagicons" component={FlagIcons} />
        <Route path="/pe7icons" component={PE7Icons} />
        <Route path="/simplelineicons" component={SimplelineIcons} />
        <Route path="/themifyicons" component={ThemifyIcons} />
        <Route path="/weathericons" component={WeatherIcons} />
        <Route path="/typiconicons" component={TypiconIcons} />

        <Route path="/ribbon" component={Ribbon} />
        <Route path="/dragdrop" component={DragDrop} />
        <Route path="/clipboard" component={Clipboard} />
        <Route path="/rating" component={Rating} />
        <Route path="/texteditor" component={Texteditor} />
        <Route path="/counter" component={Counter} />
        <Route path="/scrollbar" component={Scrollbar} />
        <Route path="/notification" component={Notification} />
        <Route path="/stickynote" component={Stickynote} />
        <Route path="/timeline" component={Timeline} />
        <Route path="/horizontaltimeline" component={HorizontalTimeLine} />
        <Route path="/formwizard" component={Formwizard} />

        <Route path="/apexchart" component={ApexCharts} />
        <Route path="/chartjs" component={ChartJs} />
        <Route path="/morrischart" component={MorrisCharts} />
        <Route path="/flotchart" component={FlotCharts} />
        <Route path="/peitychart" component={PeityChart} />
        <Route path="/c3chart" component={C3Charts} />

        <Route path="/tooltip" component={UiTooltip} />
        <Route path="/toast" component={Toastr} />
        <Route path="/spinner" component={Spinner} />
        <Route path="/popover" component={PopOver} />
        <Route path="/rangeslider" component={RangeSlider} />
        <Route path="/lightbox" component={LightBox} />
        <Route path="/cards" component={Cards} />
        <Route path="/dropdown" component={Dropdown} />
        <Route path="/pagination" component={Pagination} />
        <Route path="/avatar" component={Tableavatar} />
        <Route path="/tabs" component={Tabs} />
        <Route path="/typography" component={Typography} />
        <Route path="/progressbar" component={Progressbar} />
        <Route path="/buttons" component={Buttons} />
        <Route path="/video" component={Video} />
        <Route path="/sweetalert" component={Sweetalert} />
        <Route path="/images" component={Images} />
        <Route path="/grid" component={Grid} />
        <Route path="/buttongroup" component={ButtonGroup} />
        <Route path="/badge" component={Badge} />
        <Route path="/accordion" component={Accordion} />
        <Route path="/alert" component={Alert} />
        <Route path="/placeholder" component={PlaceHolder} />
        <Route path="/offcanvas" component={OffCanvas} />
        <Route path="/media" component={Media} />
        <Route path="/carousel" component={Carousel} />
        <Route path="/breadcrumbs" component={BreadCrumbs} />
        <Route path="/modal" component={Modal} />
      </Switch>
    </Router>
  );
};

export default appcontainer;